import React, { useEffect, useState } from "react";
import { loadYaml } from "../utils/loadYaml";
import { HeroSection } from "../components/herosection";
import { BifurcatedPromo } from "../components/BifurcatedPromo";
import { FeatureGrid } from "../components/FeatureGrid";
import { ProductGrid } from "../components/productgrid";

interface Section {
  type: string;
  id?: string;
  [key: string]: any;
}

const Cloud: React.FC = () => {
  const [sections, setSections] = useState<Section[]>([]);

  useEffect(() => {
    loadYaml("/config/cloud.yaml").then((data: { sections: Section[] }) => {
      setSections(data.sections);
    });
  }, []);

  return (
    <div>
      {sections.map((s, idx) => {
        switch (s.type) {
          case "hero":
            return <HeroSection carousel={[]} key={idx} {...s} />;
          case "bifurcatedPromo":
            return <BifurcatedPromo title={""} left={s.left} right={s.right} key={idx} {...s} />;
          case "featureGrid":
            return <FeatureGrid title={""} features={[]} key={idx} {...s} />;
          case "productGrid":
            return <ProductGrid title={""} products={[]} key={idx} {...s} />;
          default:
            return null;
        }
      })}
    </div>
  );
};

export default Cloud;
